import React from 'react';
import './MediaPreview.css';

const MediaPreview = ({ mediaFiles, onRemove }) => {
  if (mediaFiles.length === 0) return null;

  return (
    <div className="media-preview">
      {mediaFiles.map((media, index) => (
        <div key={index} className="media-item">
          {media.file.type.startsWith('image/') ? (
            <img crossorigin="anonymous" src={media.url} alt="Preview" className="media-image" />
          ) : media.file.type.startsWith('video/') ? (
            <video crossorigin="anonymous" src={media.url} controls className="media-video" />
          ) : media.file.type === 'application/pdf' ? (
            <iframe
            crossorigin="anonymous"
              src={media.url}
              title={media.file.name}
              className="media-pdf"
              style={{ width: '100%', height: '150px', border: 'none' }}
            />
          ) : (
            <div className="media-document">
              <a
                href={media.url}
                target="_blank"
                rel="noopener noreferrer"
                className="media-document-link"
              >
                <span className="media-document-icon">📄</span>
                <span>{media.file.name}</span>
              </a>
            </div>
          )}
          <button
            className="remove-media-button"
            onClick={() => onRemove(index)}
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
};

export default MediaPreview;